var _style, _g, _g2, _g3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgButterfly2 = function SvgButterfly2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eqinm20cpmn1",
    className: "butterfly2",
    viewBox: "0 0 100 100",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes eqinm20cpmn2_to__to{0%,to{transform:translate(50.000003px,55.520401px)}18%{transform:translate(50.000003px,55.015931px)}28%{transform:translate(48.835924px,53.843062px)}35.6%{transform:translate(48.355924px,53.843062px);animation-timing-function:cubic-bezier(0,0,.58,1)}54%{transform:translate(48.401883px,54.506593px)}62%{transform:translate(48.679817px,52.682907px)}}@keyframes eqinm20cpmn3_ts__ts{0%,22%,32.4%,56.2%,94.4%,99.8%,to{transform:translate(25px,25px) scale(1,1)}16%,37.8%,50%,68%{transform:translate(25px,25px) scale(1,1);animation-timing-function:cubic-bezier(.445,.05,.55,.95)}18.8%,33.8%,52.2%,92%,95.8%{transform:translate(25px,25px) scale(.395834,1)}28%,90%{transform:translate(25px,25px) scale(1,1);animation-timing-function:cubic-bezier(.39,.575,.565,1)}30%{transform:translate(25px,25px) scale(.417924,1)}60%{transform:translate(25px,25px) scale(.395834,1);animation-timing-function:cubic-bezier(.42,0,.58,1)}}@keyframes eqinm20cpmn13_ts__ts{0%,22%,32.4%,56.2%,94.4%,99.8%,to{transform:translate(25px,25px) scale(1,1)}16%,37.8%,50%,68%{transform:translate(25px,25px) scale(1,1);animation-timing-function:cubic-bezier(.445,.05,.55,.95)}18.8%,30%,33.8%,52.2%,92%,95.8%{transform:translate(25px,25px) scale(.395834,1)}28%,90%{transform:translate(25px,25px) scale(1,1);animation-timing-function:cubic-bezier(.39,.575,.565,1)}60%{transform:translate(25px,25px) scale(.395834,1);animation-timing-function:cubic-bezier(.42,0,.58,1)}}")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 55.52)",
    style: {
      animation: "eqinm20cpmn2_to__to 5000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "eqinm20cpmn2",
    transform: "scale(-1 1) rotate(26.73 65.1 -40.1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 25)",
    style: {
      animation: "eqinm20cpmn3_ts__ts 5000ms linear infinite normal forwards"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eqinm20cpmn3",
    transform: "translate(-25 -25)",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn4",
    d: "M94.77 93.49c-6.23-6.58-13.84-9.86-17.87-7.89-4.03 1.97-2.6 14.55 8.28 21.61-4.33 3.19-1.22 6.85.95 7.82 0 0-4 5.88-1.84 6.36 2.16.48 4.33-5.64 4.33-5.64 2.48.49 5.58-1.48 6.82-3.44z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn5",
    d: "M93.38 95.33c-4-3.17-9.34-8.41-12.28-6.69-2.94 1.72-.9 11 5.63 14.9-1.24 1.84 1.57 7.45 7.3 4.74z",
    transform: "translate(-70.66 -77.43)",
    fill: "#CA892E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn6",
    d: "M90.89 92.65s-2.32 4.65-.92 5c1.4.35 2.16-4.41 2.16-4.41z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn7",
    d: "M88.71 90.45s-.61 5.26-1.85 5.14c-1.24-.12.6-5.86.6-5.86z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn8",
    d: "M85.76 88.87s.16 3.3-1.24 3.31c-1.4.01 0-4 0-4z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn9",
    d: "M91.38 102.67a1.09 1.09 0 11-2.18-.02 1.09 1.09 0 012.18.02z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn10",
    d: "M92.8 112.2a.93.93 0 11-.93-.86.89.89 0 01.93.86z",
    transform: "translate(-70.66 -77.43)",
    fill: "#CA892E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn11",
    d: "M89.7 112.45a.9.9 0 01-.93.86.86.86 0 110-1.71.9.9 0 01.93.85z",
    transform: "translate(-70.66 -77.43)",
    fill: "#CA892E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn12",
    d: "M87.21 110.63a.93.93 0 11-.93-.86.89.89 0 01.93.86z",
    transform: "translate(-70.66 -77.43)",
    fill: "#CA892E"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 25)",
    style: {
      animation: "eqinm20cpmn13_ts__ts 5000ms linear infinite normal forwards"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "eqinm20cpmn13",
    transform: "translate(-25 -24.2)",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn14",
    d: "M96.57 92.75c6.19-6.62 13.79-9.94 17.83-8 4.04 1.94 2.68 14.54-8.17 21.66 4.35 3.16 1.26 6.84-.91 7.82 0 0 4.05 5.86 1.88 6.35-2.17.49-4.36-5.6-4.36-5.6-2.48.49-5.59-1.45-6.84-3.41z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn15",
    d: "M98 94.58c4-3.19 9.29-8.46 12.25-6.76 2.96 1.7 1 11-5.55 14.93 1.24 1.83-1.53 7.46-7.28 4.79z",
    transform: "translate(-70.66 -77.43)",
    fill: "#CA892E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn16",
    d: "M100.45 91.88s2.34 4.64.94 5c-1.4.36-2.18-4.39-2.18-4.39z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn17",
    d: "M100.45 91.88s2.34 4.64.94 5c-1.4.36-2.18-4.39-2.18-4.39z",
    transform: "matrix(1.19409 -.23654 .16414 .8286 -102.99 -40.67)",
    fill: "#3B2314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn18",
    d: "M100.45 91.88s2.34 4.64.94 5c-1.4.36-2.18-4.39-2.18-4.39z",
    transform: "matrix(.59655 -.2273 .35606 .93446 -58.54 -54.2)",
    fill: "#3B2314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn19",
    d: "M100 101.91a1.09 1.09 0 102.18-.04 1.09 1.09 0 00-2.18.04z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn21",
    d: "M98.64 111.44a.93.93 0 10.93-.85.9.9 0 00-.93.85z",
    transform: "translate(-70.66 -77.43)",
    fill: "#CA892E"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "eqinm20cpmn23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn24",
    d: "M94.61 91.66c-1.08 2.57-2.57 24.45 1.31 24.44 3.88-.01 1.19-17.24.86-23.72z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn25",
    d: "M98.33 90.91a2.71 2.71 0 11-2.64-2.07c1.3-.14 2.46.78 2.64 2.07z",
    transform: "translate(-70.66 -77.43)",
    fill: "#3B2314",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn26",
    d: "M24.26 12.64c0-2.94-3.12-6.1-5.76-5.6",
    fill: "none",
    stroke: "#3B2314",
    strokeWidth: 0.41,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "eqinm20cpmn27",
    d: "M26.12 12.88c1.08-2.94 2.3-6.37 5.57-6.87",
    fill: "none",
    stroke: "#3B2314",
    strokeWidth: 0.41,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButterfly2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/butterfly2.baf45d33.svg";
export { ForwardRef as ReactComponent };